import React from 'react'

import moment from 'moment'

import {Check} from '../../../../components/UI/forms/index.js'
import {Badge, ListItem, P} from '../../../../components/UI/index.js'
import {formatPrice} from '../../../../../utils/price.js'

class InvoiceListItem extends React.Component {
    render() {
        const {invoice, selected, onSelect, onClick} = this.props

        let totalPrice = 0

        invoice.invoiceLines.map((invoiceLine) => {
            totalPrice += invoiceLine.quantity * invoiceLine.price
        })

        return (
            <ListItem onClick={onClick}>
                <Check checked={selected} onChange={onSelect} />
                <P style={{flex: 2, marginLeft: 30}}>{invoice?.resellerDisplayName && invoice?.resellerDisplayName !== invoice.reseller ? `${invoice?.resellerDisplayName} (${invoice.reseller})` : invoice.reseller}</P>
                <P style={{width: 200, marginLeft: 30, textTransform: 'capitalize'}}>{moment(invoice.month).locale('NL').format('MMMM YYYY')}</P>
                <P style={{width: 200, marginLeft: 30}}>{invoice.maxLicensesDate ? moment(invoice.maxLicensesDate).locale('NL').format('DD-MM-YYYY') : ''}</P>
                <P style={{width: 130, marginLeft: 30}}>{`€ ${formatPrice(totalPrice)}`}</P>

                <div style={{flex: 1, marginLeft: 30}}>
                    {invoice.status === 'Concept' &&
                        <Badge variant='info' style={{width: 80}}>Concept</Badge>
                    }
                </div>
            </ListItem>
        )
    }
}

export default (InvoiceListItem)
